import {
  IAppNavConfig,
  IFooterNavItems,
  IFooterSocialMedia,
  IMainNavItems,
} from "@wesr/wesr-common";
import { fetchContentWithFallback } from "../Content";

export const loadAppNavConfig = async (): Promise<IAppNavConfig[]> => {
  const response = await fetchContentWithFallback("/config/navigation/app-nav.json");
  const data = await response.json();
  return data.items;
};

export const loadNavigationConfig = async (): Promise<IMainNavItems[]> => {
  const response = await fetchContentWithFallback("/config/navigation/main-navigation.json");
  const data = await response.json();
  return data.items;
};

export const loadFooterConfig = async (): Promise<{
  items: IFooterNavItems[];
  icons: IFooterSocialMedia[];
}> => {
  const response = await fetchContentWithFallback("/config/navigation/footer-navigation.json");
  const data = await response.json();
  return data;
};
